import cn from 'classnames';

import styles from './Steps.module.css';

const SelectList = (props) => {
  const { defaultValue, onChange, options } = props;

  return (
    <div className={styles.shareMealsSelect}>
      {options.map((data) => (
        <div 
          key={data.value} 
          className={cn(styles.shareMealButton, { [styles.active]: data.value === defaultValue})}
          onClick={() => onChange(data.value)}
        >
          {data.label}
        </div>
      ))}
    </div>
  );
};

export default SelectList;